import './App.css';
import React from 'react'
import SocialPage from './Pages/SocialPage';


function App() {
  return (
    <div>
      <SocialPage/>
    </div>
  );
}

export default App;
